import React from 'react';

const ContentManagement = () => {
    return ( <div></div> );
}
 
export default ContentManagement;